let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3LT6Y")).then(() => parcelRequire('k85Dj'));